export const siteConfig = {
  name: 'The Midnight Sanctuary',
  shortName: 'Midnight Sanctuary',
  tagline: 'Good vibes. Cozy nights. Magical minds.',
  domain: 'https://themidnightsanctuary.co.uk',
  description:
    'A warm Discord community for good vibes, cosy nights, gaming, creativity and magical minds.',
  logoPath: '/assets/midnight-sanctuary-logo.jpg',
  heroArtworkPath: '/assets/sanctuary-hero.png',
  discordInviteUrl: import.meta.env.VITE_DISCORD_INVITE_URL || '',
  contactEmail: import.meta.env.VITE_CONTACT_EMAIL || '',
  socials: {
    instagram: import.meta.env.VITE_INSTAGRAM_URL || '',
    tiktok: import.meta.env.VITE_TIKTOK_URL || '',
  },
}

export const mainNavigation = [
  { label: 'Home', to: '/' },
  { label: 'The Sanctuary', to: '/sanctuary' },
  { label: 'Community', to: '/community' },
  { label: 'Events', to: '/events' },
  { label: 'Gallery', to: '/gallery' },
]
